import api from './authService';

export const getClients = async () => {
    const response = await api.get('/clients');
    return response.data;
};

export const getClientById = async (id) => {
    const response = await api.get(`/client/${id}`);
    return response.data;
};

export const createClient = async (clientData) => {
    const response = await api.post('/client/create', clientData);
    return response.data;
};

export const updateClient = async (id, clientData) => {
    const response = await api.put(`/client/${id}`, clientData);
    return response.data;
};

export const deleteClient = async (id) => {
    const response = await api.delete(`/client/${id}`);
    return response.data;
};

export const deleteSelectedClients = async (ids) => {
    const response = await api.delete('/clients', { data: { ids } });
    return response.data;
};

export const createClientAdmin = async (clientId, adminData) => {
    const response = await api.post(`/client/${clientId}/admin`, adminData);
    return response.data;
};

export const getClientStatus = async (clientId) => {
    const response = await api.get(`/client/${clientId}/admin/status`);
    return response.data;
};

export const getClientConfig = async () => {
    const response = await api.get('/client-config');
    return response.data;
};

export const uploadClientLogo = async (clientId, file) => {
    const formData = new FormData();
    formData.append('logo', file);
    const response = await api.post(`/client/${clientId}/logo`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
};

export const updateClientBranding = async (clientId, branding) => {
    const response = await api.put(`/client/${clientId}/branding`, branding);
    return response.data;
};

export const updateBackupConfig = async (clientId, configData) => {
    const response = await api.patch(`/client/${clientId}/backup-config`, configData);
    return response.data;
};

export const injectClasses = async (clientId, classes) => {
    const response = await api.post(`/client/${clientId}/inject-classes`, { classes });
    return response.data;
};

export const getGlobalMobileApp = async () => {
    const response = await api.get('/global/mobile-app');
    return response.data;
};

export const updateGlobalMobileApp = async (data) => {
    const response = await api.put('/global/mobile-app', data);
    return response.data;
};

